//#region Imports
import React from 'react';
/**
 * To use TransitBadge Component
 */
import TransitBadge from '../TransitBadge';
/**
 * To use Pedestrian Icon
 */
import { IconPedestrian } from '../../Icons';
//#endregion


/**
* It is written in Diretion>>TripLeg>>LegBody.
* Returns Leg body.
* Function is used in Directions>>TripLeg.
* @param {Object} Props
* @return {HTMLElement} Leg Body
*/
const LegBody = props => {
    //Stores leg details and text for particular leg.
    const { details, text } = props;
    //Stores css class name
    let wrapperClass = 'otp-trip-leg-details';
    if (details.mode === 'WALK') {
        wrapperClass += ' otp-walking-directions';
    }
    return (
        <div className={wrapperClass}>
            <div className="otp-icon-wrapper">{getDefaultIcon(details)}</div>
            <div className="otp-trip-divider"></div>
            <div className="otp-trip-text">{text}</div>
        </div>
    );
};

/**
* Returns Icon if mode is WALK or BUS.
* Function is used in LegBody function from the same component.
* @param {String} 'Trip Detail'
* @return {HTMLElement} Icon or Badge
*/
const getDefaultIcon = details => {
    if (details.mode === 'WALK') {
        return <IconPedestrian />;
    }
    if (details.mode === 'BUS') {
        return <TransitBadge leg={details} showName={false} />;
    }
};

export default LegBody;